import { render, staticRenderFns } from "./toubao.vue?vue&type=template&id=f3871b7a&scoped=true&"
import script from "./toubao.vue?vue&type=script&lang=ts&"
export * from "./toubao.vue?vue&type=script&lang=ts&"
import style0 from "./toubao.vue?vue&type=style&index=0&id=f3871b7a&scoped=true&lang=css&"
import style1 from "./toubao.vue?vue&type=style&index=1&id=f3871b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3871b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3871b7a')) {
      api.createRecord('f3871b7a', component.options)
    } else {
      api.reload('f3871b7a', component.options)
    }
    module.hot.accept("./toubao.vue?vue&type=template&id=f3871b7a&scoped=true&", function () {
      api.rerender('f3871b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/toubao.vue"
export default component.exports